import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Paper,
    Typography,
} from "@mui/material";

type UpdateAvailableDialogProps = {
    open: boolean;
    onRefresh: () => void;
};

export const UpdateAvailableDialog = ({ open, onRefresh }: UpdateAvailableDialogProps) => {
    const [isMinimized, setIsMinimized] = useState(false);

    const handleLater = () => {
        setIsMinimized(true);
    };

    if (!open) {
        return null;
    }

    if (isMinimized) {
        return (
            <Paper
                elevation={8}
                sx={{
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    zIndex: 1300,
                    p: 5,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    maxWidth: 360,
                }}
            >
                <Typography variant="h6" fontWeight="bold">
                    Atualização Disponível
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Para garantir o correto funcionamento do CRM, por favor, atualize assim que terminar e guardar o seu trabalho atual.
                </Typography>
                <Button onClick={onRefresh} variant="contained" color="primary">
                    Atualizar Agora
                </Button>
            </Paper>
        );
    }

    return (
        <Dialog open={open} disableEscapeKeyDown>
            <DialogTitle>Atualização Disponível</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Uma nova versão da aplicação está disponível. Por favor, atualize a página para
                    continuar a usar a aplicação com as últimas funcionalidades.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleLater} variant="outlined">
                    Mais tarde
                </Button>
                <Button onClick={onRefresh} variant="contained" color="primary" autoFocus>
                    Atualizar Agora
                </Button>
            </DialogActions>
        </Dialog>
    );
};

